<template>
    <label class="io-switch" :class="{ 'is-active' : isChecked }">
        <input type="checkbox" :name="name" :false-value="defaultValue" :true-value="activeValue" v-model="dataValue" ref="checkbox" @change="onChange">
        <div v-if="label && labelIsObject()" class="label">
            {{ label.default }}
        </div>
        <div class="ripple">
            <span>
                &nbsp;
            </span>
            <span>
                &nbsp;
            </span>
        </div>
        <div class="label" v-if="label" v-html="activeLabel"></div>
    </label>
</template>

<script>
export default {
  name: 'IoSwitch',

  model: {
    prop: 'switchValue',
    event: 'change',
  },

  props: {
    value: {
      required: true,
    },
    switchValue: {
      required: false,
    },
    name: {
      required: true,
    },
    label: {
      required: false,
    },
  },

  data() {
    return {
      dataValue: this.switchValue,
    };
  },

  computed: {
    isChecked() {
      if (!Array.isArray(this.dataValue)) {
        return this.dataValue == this.activeValue;
      }
      return this.switchValue.includes(this.activeValue);
    },
    returnVal() {
      return this.isChecked ? this.activeValue : this.defaultValue;
    },
    activeValue() {
      return !this.valueIsObject() ? this.value : this.value.active;
    },
    defaultValue() {
      return !this.valueIsObject() ? null : this.value.default;
    },
    activeLabel() {
      return !this.labelIsObject() ? this.label : this.label.active;
    },
  },

  mounted() {
    if (!Array.isArray(this.switchValue)) {
      this.onChange();
    }
  },

  methods: {
    valueIsObject() {
      return typeof this.value === 'object';
    },
    labelIsObject() {
      return typeof this.label === 'object';
    },
    onChange(e) {
      if (!Array.isArray(this.switchValue)) {
        this.$emit('change', this.returnVal);
      } else if (this.switchValue.includes(this.activeValue)) {
        this.switchValue.splice(this.switchValue.indexOf(this.activeValue), 1);
      } else {
        this.switchValue.push(this.activeValue);
      }

      this.$emit('toggle');
    },
  },
};
</script>
